import { StyleSheet } from 'react-native';

export const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    alignSelf: 'center',
  },
  balanceText: {
    fontSize: 16,
    fontWeight: 'bold',
  },
});
